import { render, staticRenderFns } from "./notificationItem.vue?vue&type=template&id=edf2991c&scoped=true&"
import script from "./notificationItem.vue?vue&type=script&lang=js&"
export * from "./notificationItem.vue?vue&type=script&lang=js&"
import style0 from "./notificationItem.vue?vue&type=style&index=0&id=edf2991c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf2991c",
  null
  
)

export default component.exports